import gql from 'graphql-tag';
const KEYBOARDING_DYNAMIC_CONTENT_FRAGMENT = gql `
  fragment KeyboardingDynamicContentFragment on KeyboardingDynamicContent {
    layout
    items {
      textHtml {
        id
        elements
      }
      image {
        id
        imageId
        image {
          id
          src
        }
      }
      table {
        labelHtml {
          id
          elements
        }
        headers {
          label
          columnType
        }
        rows {
          values {
            value
            correct
          }
        }
      }
      scrollableText {
        id
        width
        height
        textHtml {
          id
          elements
        }
      }
      dynamicContent {
        layout
        items {
          textHtml {
            id
            elements
          }
          image {
            id
            imageId
            image {
              id
              src
            }
          }
          table {
            labelHtml {
              id
              elements
            }
            headers {
              label
              columnType
            }
            rows {
              values {
                value
                correct
              }
            }
          }
          scrollableText {
            id
            width
            height
            textHtml {
              id
              elements
            }
          }
        }
      }
    }
  }
`;
export default KEYBOARDING_DYNAMIC_CONTENT_FRAGMENT;
